import React, { forwardRef, useState } from 'react';
import { Image as WebImage } from 'react-native-web';
import { directFromProxy, optimizeImageUri, useCloudinarySource } from './cloudinary';

const MODES = { cover: 'cover', contain: 'contain', fill: 'stretch', none: 'center', 'scale-down': 'contain' };

function normalize(source, style?) {
  if (source && typeof source === 'object' && typeof source.src === 'string') return { uri: source.src, width: source.width, height: source.height };
  if (source && typeof source === 'object' && source.default && typeof source.default.src === 'string') return { uri: source.default.src };
  if (source && typeof source === 'object' && typeof source.uri === 'string') return { ...source, uri: optimizeImageUri(source.uri, style) };
  return source;
}

/** expo-image's <Image>, drawn with the browser's own image: contentFit becomes resizeMode. */
export const Image = forwardRef<any, any>(function Image({ source, contentFit = 'cover', transition, placeholder, cachePolicy, recyclingKey, priority, ...rest }, ref) {
  const sized = useCloudinarySource(source, rest.style, rest.onLayout);
  const resolved = normalize(sized.source, rest.style);
  // If the photo cannot be fetched through salunbd.com/img, ask Cloudinary for it directly rather than show an empty box.
  const [failedUri, setFailedUri] = useState<string | null>(null);
  const direct = resolved && typeof resolved === 'object' && failedUri === resolved.uri ? directFromProxy(resolved.uri) : null;
  const finalSource = direct ? { ...resolved, uri: direct } : resolved;
  const onError = (event) => {
    if (resolved && typeof resolved === 'object' && directFromProxy(resolved.uri)) setFailedUri(resolved.uri);
    rest.onError?.(event);
  };
  return <WebImage ref={ref} resizeMode={MODES[contentFit] || 'cover'} {...rest} source={finalSource} onLayout={sized.onLayout} onError={onError} />;
});

export default Image;
